/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  var $agreeCheckbox = $("input[name='agree-checkbox");
  var $btnModal = $("#btn-modal");
  var $modalTrigger = $('.modal-trigger');

  var checkData = localStorage.getItem("checkData");
  if (checkData == "yes") {
    $agreeCheckbox.prop('checked', true);
  }
  else if(checkData == "no"){
    $agreeCheckbox.prop('checked', false);
  }


  $btnModal.attr('disabled',true);

  if ($agreeCheckbox.is(":checked")) {
    $btnModal.attr('disabled',false);
    $modalTrigger.removeAttr("data-toggle");

  } else {
    $btnModal.attr('disabled',true);
    $modalTrigger.attr("data-toggle", "modal");
  }

  $agreeCheckbox.on('click', function (event) {

    if ($(this).prop("checked")) {
      $btnModal.attr('disabled',false);
      $modalTrigger.removeAttr("data-toggle");
      localStorage.setItem("checkData", "yes");

    } else {
      $btnModal.attr('disabled',true);
      $modalTrigger.attr("data-toggle", "modal");
      localStorage.setItem("checkData", "no");
    }


  });

  $btnModal.on('click', function (event) {
    if ($btnModal.attr('disabled',false)) {
      document.location.href = "./index.php";
    }
  });
});

jQuery(function ($) {
  $('.modal-link').on('click', function(e) {
    e.preventDefault();
    $modal = $(this).attr('data-modal-link');
    $('[data-modal-id="' + $modal +'"]').fadeIn();
  });

  $('.btn-close, .section-modal__overlay').on('click', function(e) {
    e.preventDefault();
    $('.section-modal').fadeOut();
  });

});


